import { inject } from '@angular/core';
import { provideAppInitializer } from '@angular/core';
import { PluginRegistryService } from '@brighthub/plugin';
import { MenuKey, MenuStore } from '@brighthub/shell/data-access-menu';
import { BRIGHTNAV_ADMIN_OKTA_GROUP } from '@brighthub/admin-contract';

export function provideBrightnavPlugin() {
  return [
    provideAppInitializer(() => {
      const registry = inject(PluginRegistryService);
      registry.registerPlugin(() => {
        const menuStore = inject(MenuStore);
        menuStore.register({
          id: 'myclients',
          label: 'My Clients',
          icon: 'pi-home',
          menuKey: MenuKey.MAIN,
          route: '/brightnav/myclients',
          order: 1,
        });
        menuStore.register({
          id: 'searchedConversations',
          label: 'Searched Convos',
          icon: 'pi-list',
          menuKey: MenuKey.MAIN,
          route: '/brightnav/conversation',
          order: 2,
          groups: [BRIGHTNAV_ADMIN_OKTA_GROUP]
        });
        menuStore.register({
          id: 'employeeConversation',
          label: 'Employee Conversation',
          icon: 'pi-user',
          menuKey: MenuKey.MAIN,
          route: '/brightnav/employee',
          order: 3,
          groups: [BRIGHTNAV_ADMIN_OKTA_GROUP]
        });
      });
    }),
  ];
}
